/**
 * Client-source constants. A Firmable client sets `ClientSource.HEADER` to
 * declare which app originated the request (`app`, `mobile`, `mcp`,
 * `teammate`, `browser-extension`, `hubspot`); the api proxy sets `zeroclick` on a ZeroClick forward. The token doubles as the prefix folded into
 * `x-fbl-request-origin` on the api→search hop (`app-search-v2` →
 * `mobile-search-v2`).
 */
export type Source = 'app' | 'mobile' | 'mcp' | 'teammate' | 'browser-extension' | 'hubspot' | 'zeroclick';

/**
 * Record (not a plain array) so adding a Source member without updating this
 * set is a compile error — keeps the runtime guard exhaustive.
 */
const SOURCE_SET: Record<Source, true> = {
  app: true,
  mobile: true,
  mcp: true,
  teammate: true,
  'browser-extension': true,
  hubspot: true,
  zeroclick: true,
};

export const ClientSource = {
  HEADER: 'x-fbl-client-source',
  is: (value: unknown): value is Source => typeof value === 'string' && value in SOURCE_SET,
};
